import { createUseStyles } from "react-jss";

export const AppoimentBoardFilterStyle = createUseStyles((theme: any) => ({
    container: {
        display: "flex",
        gap: theme.gaps.filter.default,
    },
}));
